import { z } from 'zod'

export const fileNameSchema = z
  .string()
  .min(1)
  .max(255)
  .regex(/^[^/\\\p{Cc}]+$/u, 'Invalid file name')

export const fileKeySchema = z.object({
  s3Key: z.string(),
  fileName: fileNameSchema,
  contentType: z.string(),
  sizeBytes: z.number().optional(),
})

export type FileKey = z.infer<typeof fileKeySchema>
